import React, { useEffect, useRef } from "react";
import { Checkbox, Col, Modal, Row, Table, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { newsSelector, pupSelector } from "../../../services/selector/index.";
import {
  IconDetail,
  IconEdit,
  IconLock,
  IconNext,
  IconPlus,
  IconPolygon,
  IconPre,
  IconSave,
  IconSpin,
  IconXmark,
} from "../../../assets/icon";
import "../../../assets/style/table/newspost.scss";
import { useState } from "react";
import { useMemo } from "react";
import {
  setOpenPUDelete,
  setStatePUEdit,
} from "../../../services/slice/PopUpSlice";
import {
  addFirstPage,
  deletePostNews,
  getDetailPostNews,
  getLogNews,
  getPostNews,
  saveChangePromience,
  setConfigCategoris,
  setOpenDetailNews,
  setOpenModalAddNews,
  setPageNews,
  setSearchText,
} from "../../../services/slice/NewsSlice";
import TranslateText from "../TranslateText";
import { formatDate } from "../../../utils/functionCommon";
import InputSearchBox from "../Input/InputSearchBox";
import BaseButton from "../Button/BaseButton";
import { revertCategorieNews } from "../../../utils/convertNumber";
import NoSearchResults from "../NoSearchResults";
import ModalEditNews from "../Modal/edit/ModalEditNews";
import ModalShowDetail from "../Modal/getDetail/ModalShowDetail";
import ModalDelete from "../Modal/delete/ModalDelete";

const TableNews = () => {
  const dispatch = useDispatch();
  const statePup = useSelector(pupSelector);
  const newsState = useSelector(newsSelector);
  const { data, total, isOpenModalDetail, callBackRequest, dataBasePageOne } =
    newsState;
  const { dataDelete, dataEdit } = statePup;
  const [dataBackUp, setDataBackUp] = useState([]);
  const stateNews = useSelector(newsSelector);
  const [dataProminence, setDataProminence] = useState([]);
  const [page, setPage] = useState(stateNews.config.option.offset);
  const [rightClick, setRightClick] = useState({
    isOpen: false,
    x: "",
    y: "",
    value: "",
  });
  useEffect(() => {
    if (data) {
      setDataBackUp(data);
    }
  }, [data]);
  const dataSource = useMemo(() => {
    const result = dataBackUp?.map((item, index) => {
      return {
        ...item,
        categories: revertCategorieNews(item.categories),
        timeCreate: formatDate(item.timeCreate),
        STT: total > 10 && page >= 2 ? (page - 1) * 10 + index + 1 : index + 1,
        key: item.id,
      };
    });
    return result;
  }, [dataBackUp, page, total]);

  useEffect(() => {
    if (callBackRequest) {
      dispatch(getPostNews());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callBackRequest]);
  useEffect(() => {
    dispatch(getPostNews(stateNews.config));
  }, [dispatch, stateNews.config]);
  const handleShowModalDelete = (value) => {
    dispatch(
      setOpenPUDelete({ stateOpen: true, content: value.title, id: value.iden })
    );
  };
  const handleShowDetail = (value) => {
    dispatch(setOpenDetailNews({ isOpen: true, id: value.iden }));
  };
  const handleDelete = () => {
    dispatch(deletePostNews(dataDelete.id));
    dispatch(setOpenPUDelete({ stateOpen: false, content: "", id: "" }));
  };
  const handleShowEditModal = (value) => {
    dispatch(setStatePUEdit({ stateOpen: true, contentEdit: value }));
  };
  useEffect(() => {
    dispatch(setPageNews(page));
  }, [page, dispatch]);
  const handleRightClick = (e, record) => {
    e.preventDefault();
    setRightClick({
      isOpen: true,
      x: e.clientX,
      y: e.clientY - 70,
      value: record,
    });
  };
  const handleChangeProminence = (value) => {
    let dataUpdate = [...dataBackUp];
    let dataUpdateProminence = [...dataProminence];
    dataUpdate = dataUpdate.map((item) => {
      if (item.iden === value.iden) {
        if (item.prominence === 1) {
          return { ...item, prominence: 0 };
        } else return { ...item, prominence: 1 };
      } else return item;
    });
    dataUpdateProminence = dataUpdateProminence.filter(
      (item) => item.newsId !== value.iden
    );
    data.forEach((elment) => {
      if (
        elment.iden === value.iden &&
        elment.prominence === value.prominence
      ) {
        dataUpdateProminence.push({
          newsId: value.iden,
          prominence: value.prominence ? 0 : 1,
        });
      } else return;
    });
    setDataProminence(dataUpdateProminence);
    setDataBackUp(dataUpdate);
  };
  const handleSaveChange = () => {
    if (!dataProminence.length) {
      Modal.error({
        className: "wrapperModalErrConfigBanner",
        centered: true,
        width: 590,
        // title: <span style={{ fontSize: 20, fontWeight: 700 }}>Lỗi</span>,
        content: (
          <>
            <p style={{ fontSize: 20 }}>
              Chưa có sự thay đổi nào so với ban đầu
            </p>
          </>
        ),
      });
      return;
    } else {
      dispatch(saveChangePromience(dataProminence));
      setDataProminence([]);
    }
  };
  const columns = [
    {
      title: "STT",
      dataIndex: "STT",
      key: "STT",
      className: "centerCell",
      width: 90,
    },
    {
      title: "Nổi bật",
      dataIndex: "prominence",
      key: "prominence",
      className: "centerCell",
      width: 100,
      render: (_, record) => (
        <Checkbox
          checked={record.prominence}
          onChange={() => handleChangeProminence(record)}
        />
      ),
    },
    {
      title: <TranslateText text="Tiêu đề" />,
      dataIndex: "title",
      key: "title",
      className: "title collapseText pointer",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => (
        <>
          <Tooltip placement="topLeft" title={text}>
            {text}
          </Tooltip>
        </>
      ),
    },

    {
      title: <TranslateText text="Người tạo" />,
      dataIndex: "username",
      key: "username",
      className: "centerCell",
    },
    {
      title: (
        <div className="textStatus">
          <TranslateText text="Loại tin tức" />
          <span className="iconChange">
            <IconPolygon fill="#00000" />
          </span>
          <ul className="list">
            <li
              className="item"
              onClick={() => dispatch(setConfigCategoris(0))}
            >
              Tất cả
            </li>
            <li
              className="item"
              onClick={() => dispatch(setConfigCategoris(5))}
            >
              Tin tức
            </li>
            <li
              className="item"
              onClick={() => dispatch(setConfigCategoris(4))}
            >
              Tin tức an ninh
            </li>

            <li
              className="item"
              onClick={() => dispatch(setConfigCategoris(1))}
            >
              Thông báo
            </li>
            <li
              className="item"
              onClick={() => dispatch(setConfigCategoris(2))}
            >
              Khuyến báo
            </li>
            <li
              className="item"
              onClick={() => dispatch(setConfigCategoris(3))}
            >
              Cảnh báo
            </li>
          </ul>
        </div>
      ),
      dataIndex: "categories",
      key: "categories",
      className: "centerCell",
    },

    {
      title: <TranslateText text="Thời gian tạo" />,
      dataIndex: "timeCreate",
      key: "timeCreate",
      className: "centerCell",
    },

    {
      title: <TranslateText text="Chức năng" />,
      key: "action",
      dataIndex: "action",
      className: "evenSpace m10",
      render: (text, record) => {
        return (
          <div className="evenSpace" style={{ minWidth: "130px" }}>
            <span
              className="pointer iconTbl"
              onClick={() => dispatch(getLogNews(record.iden))}
            >
              <Tooltip title="Xem log">
                <IconLock />
              </Tooltip>
            </span>
            <span
              className="pointer iconTbl"
              onClick={() => handleShowDetail(record)}
            >
              <Tooltip title="Xem chi tiết">
                <IconDetail />
              </Tooltip>
            </span>
            <span
              className="pointer iconTbl"
              onClick={() => handleShowEditModal(record)}
            >
              <Tooltip title="Chỉnh sửa">
                <IconEdit />
              </Tooltip>
            </span>
            <span
              className="pointer iconTbl"
              onClick={() => handleShowModalDelete(record)}
            >
              <Tooltip title="Xóa">
                <IconXmark />
              </Tooltip>
            </span>
          </div>
        );
      },
    },
  ];
  const tableLoading = {
    spinning: newsState.isLoading, // isLoading là biến boolean để xác định xem có đang loading hay không
    indicator: <IconSpin className="iconSpin" />,
  };
  // const onSelectChange = (newSelectedRowKeys) => {
  //   if (newSelectedRowKeys.length > 2) {
  //     Modal.error({
  //       className: "wrapperModalErrConfigBanner",
  //       centered: true,
  //       width: 590,
  //       title: <span style={{ fontSize: 20, fontWeight: 700 }}>Lỗi</span>,
  //       content: (
  //         <>
  //           <p style={{ fontSize: 20 }}>Tối đa có 2 bài viết được ghim</p>
  //         </>
  //       ),
  //     });
  //     return;
  //   }
  //   let newDataGhim = [...dataGhimBackUp];
  //   // let newDatabase = [...dataBaseBackUp];
  //   let differentElements = selectedRowKeys
  //     .concat(newSelectedRowKeys)
  //     .filter(function (element, index, self) {
  //       return (
  //         self.indexOf(element) === index &&
  //         !(
  //           selectedRowKeys.includes(element) &&
  //           newSelectedRowKeys.includes(element)
  //         )
  //       );
  //     });
  //   if (newDataGhim.find((item) => item.id === differentElements[0])) {
  //     newDatabase.push({
  //       ...newDataGhim.find((item) => item.id === differentElements[0]),
  //       pin: 0,
  //     });
  //     newDataGhim = newDataGhim.filter(
  //       (item) => item.id !== differentElements[0]
  //     );
  //     setDataBaseBackUp(newDatabase);
  //     setDataGhimBackUp(newDataGhim);
  //   } else {
  //     newDataGhim.push({
  //       ...newDatabase.find((item) => item.id === differentElements[0]),
  //       pin: 1,
  //     });
  //     newDatabase = newDatabase.filter(
  //       (item) => item.id !== differentElements[0]
  //     );
  //     setDataBaseBackUp(newDatabase);
  //     setDataGhimBackUp(newDataGhim);
  //   }
  //   setSelectedRowKeys(newSelectedRowKeys);
  // };
  // const rowSelection = {
  //   selectedRowKeys,
  //   columnTitle: "Nổi bật",
  //   width: 200,
  //   onChange: onSelectChange,
  // };
  return (
    <>
      <Row>
        <Col>
          <InputSearchBox
            setText={(value) => dispatch(setSearchText(value))}
            width={400}
            placeholder="Tìm kiếm theo tiêu đề"
          />
        </Col>
        <Col style={{ flexGrow: 1, display: "flex", justifyContent: "end" }}>
          <BaseButton
            icon={
              <IconPlus
                width={16}
                height={14}
                style={{ marginRight: "0.5rem" }}
              />
            }
            styleBtn={{ marginRight: "1rem" }}
            content={`Thêm mới`}
            width={120}
            typeBtn="btnOrange"
            handleClick={() => dispatch(setOpenModalAddNews(true))}
          />
          <BaseButton
            icon={
              <IconSave
                width={16}
                height={14}
                style={{ marginRight: "0.5rem" }}
              />
            }
            content={`Lưu`}
            width={120}
            typeBtn="btnOrange"
            handleClick={() => handleSaveChange()}
          />
        </Col>
      </Row>
      {dataEdit.isOpenPUEdit && (
        <ModalEditNews titleText={"Chỉnh sửa tin tức an ninh"} />
      )}
      {isOpenModalDetail && (
        <ModalShowDetail
          getData={() => getDetailPostNews(stateNews.idNews)}
          selector={newsSelector}
          close={() => setOpenDetailNews({ isOpen: false, id: "" })}
        />
      )}
      {dataDelete.isOpenPUDelete && (
        <ModalDelete
          handleDelete={handleDelete}
          content="Bạn có đồng ý xóa bài viết không?"
        />
      )}
      <Row style={{ width: "100%" }}>
        {rightClick.isOpen ? (
          <ModalRightClick
            top={rightClick.y}
            left={rightClick.x}
            setOpen={setRightClick}
            value={rightClick.value}
          />
        ) : null}
        {newsState.config.search && !newsState.data.length ? (
          <NoSearchResults />
        ) : (
          <Table
            onRow={(record, index) => ({
              onContextMenu: (event) => handleRightClick(event, record),
            })}
            // rowSelection={rowSelection}
            loading={tableLoading}
            className="wrapperTblNewsPost"
            style={{ width: "100%", marginTop: "2.6rem" }}
            columns={columns}
            dataSource={dataSource}
            pagination={
              total > 10
                ? {
                    onChange: (value) => dispatch(setPageNews(value)),
                    total,
                    pageSize: 10,
                    current: stateNews.config.option.offset,
                    prevIcon: <IconPre />,
                    nextIcon: <IconNext />,
                    showSizeChanger: false,
                  }
                : false
            }
          />
        )}
      </Row>
    </>
  );
};

export default TableNews;

const ModalRightClick = ({ top, left, setOpen, value }) => {
  const puRef = useRef();
  const newsState = useSelector(newsSelector);
  const { dataBasePageOne, dataGhim } = newsState;
  const dispatch = useDispatch();
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  useOutsideAlerter(puRef);
  const handleClick = () => {
    if (dataBasePageOne.find((item) => item.iden === value.iden)) {
      Modal.error({
        className: "wrapperModalErrConfigBanner",
        centered: true,
        width: 590,
        title: <span style={{ fontSize: 20, fontWeight: 700 }}>Lỗi</span>,
        content: (
          <>
            <p style={{ fontSize: 20 }}>
              Bài viết đã có trong danh sách. Vui lòng thử lại.
            </p>
          </>
        ),
      });
      return;
    }
    if (dataBasePageOne.length + dataGhim.length >= 5) {
      Modal.error({
        className: "wrapperModalErrConfigBanner",
        centered: true,
        width: 590,
        title: <span style={{ fontSize: 20, fontWeight: 700 }}>Lỗi</span>,
        content: (
          <>
            <p style={{ fontSize: 20 }}>Tối đa có 5 bài viết</p>
          </>
        ),
      });
      return;
    }
    setOpen(false);
    dispatch(addFirstPage({ id: value.iden }));
  };
  return (
    <div
      onClick={handleClick}
      ref={puRef}
      style={{ position: "absolute", top: top, left: left }}
      className="btnAddToPageOne"
    >
      Thêm vào <span>Trang 1</span>
    </div>
  );
};
